export default __webpack_public_path__ + "cee15bd71a57bed45fe85cde0beb233c.png";